<template>
    <v-card elevation="2" height="100%">
        <v-card-text>
            <h2 class="display-1 mb-4">{{ title }}</h2>
            <template> </template>
        </v-card-text>
        <v-card-actions>
            <v-layout justify-end>
                <v-btn @click="getTasksReport" color="primary"> Get {{ title }} </v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    components: {},
    computed: {},
    created() {},
    props: ["title"],
    watch: {},
    data: function () {
        return {
            /*cfrStartDateMenu: false,*/
            /*cfrEndDateMenu: false,*/
            /*cfrStartDate: this.$moment().subtract(8, "weeks").format('YYYY-MM-DD'),*/
            /*cfrEndDate: this.$moment().subtract(1, "weeks").format('YYYY-MM-DD'),*/
        };
    },
    computed: {},
    methods: {
        getTasksReport: function () {
            this.$router.push({
                name: "taskReport",
                query: {
                    /*startDate: this.cfrStartDate,*/
                    /*endDate: this.cfrEndDate,*/
                },
            });
        },

        dateFormatted: function (date) {
            return date ? this.$moment(date).format("dddd, MMMM D") : "";
        },
    },
};

// - [ ] include `who completed`, `when completed`
// - [ ] Filter by "title" (to get all of the same title)
// - [ ] Filter by time period
// - [ ] Filter by "done"
// - [ ] Filter by assignee (combined with above, allows "download report of an employee's `dones`")
// - [ ] Possibly filter by task `type` (Expire, Ongoing, etc.)
</script>
